import { restClient } from '@/Core/Services/RestClientService'
import { GetCollectionRequestParamsTask } from '@/Core/Tasks/Resources/GetCollectionRequestParamsTask'
import { toJS } from 'mobx'

export const LoadActionTask = ({ listContext, forceRefresh = false }: { listContext: any; forceRefresh?: boolean }) => {
    // Функція трансформації параметрів
    const paramsTransformer =
        typeof listContext.props?.searchParamsTransformer === 'function'
            ? listContext.props.searchParamsTransformer
            : GetCollectionRequestParamsTask

    // addEvent('load_start', { timestamp: Date.now() })

    // Викликаємо onBeforeLoad event
    listContext.eventManager.emit('onBeforeLoad', { listContext })

    listContext.setIsLoading(true)

    let params: any = {
        sorter: toJS(listContext.sorter),
        filter: toJS(listContext.fullFilter),
        pagination: toJS(listContext.pagination),
    }

    // Додаємо search якщо він є в listContext
    if (listContext.search) {
        params.search = listContext.search
    }

    params = paramsTransformer(params, listContext)

    listContext.eventManager.emit('onAfterParamsTransform', { params, listContext })

    // Налаштування для RestClient з трансформерами
    const requestSettings: any = {}

    // Передаємо request трансформер якщо він вказаний
    if (listContext.props?.requestTransformer) {
        requestSettings.requestTransformer = listContext.props.requestTransformer
    }

    // Передаємо response трансформер якщо він вказаний
    if (listContext.props?.responseTransformer) {
        requestSettings.responseTransformer = listContext.props.responseTransformer
    }

    // Передаємо налаштування вимкнення трансформації
    if (listContext.props?.disableResponseTransform) {
        requestSettings.disableResponseTransform = listContext.props.disableResponseTransform
    }
    
    // Передаємо forceRefresh для примусового оновлення (очищення кешу)
    if (forceRefresh) {
        requestSettings.forceRefresh = true
    }

    // Використовуємо getStore() для автоматичної дедупликації
    const store = (restClient as any).getStore(
        listContext.restUrl,
        { searchParams: params },
        requestSettings
    )

    // Якщо store вже має дані (з кешу або активний запит)
    if (store) {
        // Використовуємо існуючий промис
        store
            .getResponse()
            .then((data: any) => {
                
                listContext.eventManager.emit('onAfterRequest', { data, listContext })

                // Перевіряємо чи data визначений
                if (!data) {
                    console.warn('LoadActionTask: Response data is undefined')
                    listContext.setIsLoading(false)
                    return
                }

                let items: any[] = []
                let totalItems: number | undefined

                // Якщо data має структуру з items та meta (трансформована відповідь)
                if (typeof data === 'object' && 'items' in data) {
                    items = data.items || []
                    // Перевіряємо різні формати метаданих
                    if (data.meta) {
                        totalItems =
                            data.meta.totalItems ?? // API Platform
                            data.meta.total ?? // Laravel / Простий формат
                            data.meta.count ?? // Results формат
                            undefined
                    }
                } else if (Array.isArray(data)) {
                    // Якщо data є масивом (без трансформації або array трансформер)
                    items = data
                }

                // Викликаємо onItem для кожного елемента
                if (Array.isArray(items)) {
                    for (let i = 0; i < items.length; i++) {
                        listContext.eventManager.emit('onItem', {
                            item: items[i],
                            data,
                            listContext,
                        })
                    }
                }

                // Оновлюємо pagination якщо є загальна кількість
                if (totalItems !== undefined) {
                    listContext.setPagination({
                        ...listContext.pagination,
                        total: totalItems,
                    })

                    listContext.setStates({
                        total: totalItems,
                    })

                    // Визначаємо чи є наступна/попередня сторінка
                    const currentPage = listContext.pagination.current || 1
                    const pageSize = listContext.pagination.pageSize || 10
                    const totalPages = Math.ceil(totalItems / pageSize)

                    listContext.setIssetNextPage(currentPage < totalPages)
                    listContext.setIssetPrevPage(currentPage > 1)
                }

                listContext.setMeta(data.meta || {})
                listContext.setItems(items)
                // Викликаємо onAfterLoad event
                listContext.eventManager.emit('onAfterLoad', {
                    listContext,
                    items,
                })

                listContext.setIsLoading(false)
                // if (typeof onReload === 'function') {
                // onReload({ items, loadData })
                // }

                // setStatus('active')
        })
        .catch((error: any) => {
            console.error('List loading error:', error)
            listContext.setIsLoading(false)
            // Викликаємо onError event
            listContext.eventManager.emit('onError', { error, listContext })

            // addEvent('load_error', { error: error.message })
            // setStatus('error')
        })
    }
}
